import moment from "moment";
import { useState } from "react";
import { PiMapPinLineFill } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import ModalAlt from "../../../components/modal/ModalAlt";
import { home } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";
import ReAssignForm from "../../property/ReAssignForm";

const VisitsCard = (props) => {
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div className="mb-2">
                <div className="flex items-center justify-between gap-1">
                    <div className="flex items-center gap-1">
                        <img src={home} alt="dashboard" className="h-2" />
                        <P className="font-vietnam text-sm text-primary truncate">
                            {props?.plantName}
                        </P>
                    </div>
                    <div className="flex items-center gap-1">
                        <P className="font-vietnam text-xs text-gray-370">
                            {moment(props?.surveyDate * 1000).format(
                                "DD/MM/yyyy"
                            )}
                        </P>
                        <div className="w-0.5 h-0.5 bg-gray-370 rounded-full"></div>
                        <P className="font-vietnam text-xs text-gray-370">
                            {moment(props?.surveyDate * 1000).format("hh:mm A")}
                        </P>
                    </div>
                </div>
                <div className="flex items-center justify-between gap-1 my-1">
                    <div className="flex items-center gap-0.5">
                        <PiMapPinLineFill className="text-base" />
                        <P className="text-xs text-secondary truncate font-vietnam">
                            {props?.address}
                        </P>
                    </div>
                    <P className="text-xs text-secondary truncate font-vietnam">
                        {props?.contactPersonName}
                    </P>
                </div>

                <button
                    onClick={() => {
                        if (document.body.clientWidth < 800) {
                            history.push(
                                `/admin/dashboard/generate/${props.plantId}?current=1`
                            );
                        } else {
                            setIsOpen((prev) => !prev);
                        }
                    }}
                    className="text-sm  text-blue-100 font-vietnam underline font-light"
                >
                    Reassign
                </button>
            </div>
            <div className="hidden lg:block">
                <ModalAlt
                    isOpen={isOpen}
                    contentClass={"bg-white"}
                    onClose={() => {
                        setIsOpen((prev) => !prev);
                    }}
                    innerTimes={false}
                    topPadding={"20px"}
                >
                    <div className="bg-white rounded-2">
                        <div className="bg-gray-100 p-1 rounded-lg mb-1 w-full text-center">
                            <P>Reassign</P>
                        </div>
                        <ReAssignForm
                            surveyD={props?.surveyDate}
                            details={props}
                            plantId={props?.plantId}
                        />
                    </div>
                </ModalAlt>
            </div>
        </>
    );
};

export default VisitsCard;
